import { apiFetch } from "@/lib/api";

export type SessionExchangeResponse = {
  ok: boolean;
  username: string;
  role: string;
  roles: string[];
};

/** Mirror the active first-party Kratos session into Tktic's own app
 * session (`tktic_session` + `tktic_csrf` cookies). Call after any
 * completed Kratos ceremony — login, registration + verification,
 * recovery. The backend enforces verified email and account status. */
export function exchangeKratosSession(): Promise<SessionExchangeResponse> {
  return apiFetch<SessionExchangeResponse>("/api/auth/session/exchange", {
    method: "POST",
    scope: false,
  });
}

export function linkKratosSocialSession(
  password: string,
): Promise<SessionExchangeResponse> {
  return apiFetch<SessionExchangeResponse>("/api/auth/session/link-social", {
    method: "POST",
    body: { password },
    scope: false,
  });
}
